import xhr from './modules/xhr';
import defaultOptions from './modules/default-options';
import { getQueryString, isValidUrl } from './modules/helpers';
import method from './modules/method';

export default function req() {
    const options = { ...defaultOptions };

    this.withBaseUrl = value => {
        options.baseUrl = value;
        return this;
    }

    this.withUrl = value => {
        if (!isValidUrl(value)) throw 'Url is not valid.';

        options.url = value;
        return this;
    }

    this.withData = value => {
        options.data = value;
        return this;
    }

    this.withQueryString = value => {
        options.queryString = typeof value === 'string' ? value : getQueryString(value);
        return this;
    }

    this.withHeaders = headers => {
        options.headers = headers;
        return this;
    }

    this.withTimeout = value => {
        options.timeout = value;
        return this;
    }

    this.withCredentials = () => {
        options.withCredentials = true;
        return this;
    }

    this.withResponseType = value => {
        options.responseType = value;
        return this;
    }

    this.withXsrfConfig = (cookieName, headerName) => {
        options.xsrf.cookieName = cookieName;
        options.xsrf.headerName = headerName;
        return this;
    }

    this.withAuth = (username, password) => {
        options.auth.username = username;
        options.auth.password = password;
        return this;
    }

    this.withBearerToken = (token) => {
        options.bearerToken = token;
        return this;
    }

    this.withTransformRequest = func => {
        options.transform.request = func;
        return this;
    }

    this.withTransformResponse = func => {
        options.transform.response = func;
        return this;
    }

    this.onBeforeSend = func => {
        options.onBeforeSend = func;
        return this;
    }

    this.onProgress = func => {
        options.onProgress = func;
        return this;
    }

    this.get = () => xhr({ ...options, method: method.GET });

    this.head = () => xhr({ ...options, method: method.HEAD });

    this.post = () => xhr({ ...options, method: method.POST });

    this.put = () => xhr({ ...options, method: method.PUT });

    this.delete = () => xhr({ ...options, method: method.DELETE });

    this.options = () => xhr({ ...options, method: method.OPTIONS });

    this.patch = () => xhr({ ...options, method: method.PATCH });
}